/**
 * The tabs of Settings (routes/platform/admin.tsx SettingsPage; the 2026-10-06 next-phase plan, step 3): their order,
 * which only an org admin opens, and the tab an address names. Pure.
 */

/** The tabs of Settings, in its order (the 2026-10-06 next-phase plan, step 3: Settings as one page with tabs). */
export type SettingsTab =
  | "organisation"
  | "people"
  | "plant-time"
  | "units"
  | "email"
  | "security"
  | "devices"
  | "consultant"
  | "packs"
  | "help";

export const SETTINGS_TABS: readonly { id: SettingsTab; label: string; admin?: boolean }[] = [
  { id: "organisation", label: "Organisation" },
  { id: "people", label: "People and roles", admin: true },
  { id: "plant-time", label: "Plant time and shifts" },
  // The units the plant reads its numbers in (migration 0202, #1177): every member reads them, an org admin sets them.
  { id: "units", label: "Units" },
  { id: "email", label: "Email" },
  { id: "security", label: "Security and privacy" },
  { id: "devices", label: "Agent keys", admin: true },
  // "usage", so it never reads as the menu's Limits (the process windows): the Navigation review's N7.
  { id: "consultant", label: "Consultant usage" },
  { id: "packs", label: "Packs and features" },
  { id: "help", label: "Help and tutorials" },
];

/** The old Admin page's tabs, by the Settings tab that holds each now. */
const OLD_ADMIN_TABS: Record<string, SettingsTab> = {
  branding: "organisation",
  team: "people",
  privacy: "security",
};

/**
 * The tab a ?tab= names, for this person: one they may open, else Organisation. An old Admin tab's name lands on the
 * tab that holds it now.
 */
export function settingsTabOf(raw: string | null, canAdmin: boolean): SettingsTab {
  const id = raw ? (OLD_ADMIN_TABS[raw] ?? raw) : "organisation";
  const tab = SETTINGS_TABS.find((t) => t.id === id);
  return tab && (!tab.admin || canAdmin) ? tab.id : "organisation";
}
